import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator';
import { PersonaFisica as PersonaFisicaBuscador } from '@conacyt/buscador-cvu';
import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';
import { IPersona, Persona } from '@/shared/model/persona/persona.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import BuscadorPersonaComponent from '../buscador-persona/buscador-persona.component';

@Component
export default class DatosBecarioComponent extends Vue {
  public personaCvu: PersonaFisicaBuscador = null;

  @Prop({ default: false })
  public saving: boolean;

  @Prop({ default: false })
  public solicitud: Solicitud;

  @Prop({ default: false })
  public readOnly: boolean;

  public persona = new Persona();

  @Ref('buscador') readonly buscadorPersonaComponent!: BuscadorPersonaComponent;

  /**
   * Carga inicial
   */
  mounted() {
    if (this.solicitud?.beneficiario != null) {
      this.persona = this.solicitud.beneficiario;
    }
  }

  /**
   * Guarda en la solicitud la información del becario.
   */
  @Emit('guardarPersona')
  public savePersona() {
    const datosEnviar = {
      beneficiario: this.persona,
    };
    return datosEnviar;
  }

  /**
   * Manejador de evento para cuando se busca una persona
   * @param persona La persona a agregar
   */
  public agregarPersona(persona: IPersona) {
    this.persona = persona;
  }
}
